import Broadcast from "../models/Broadcast";

const BroadcastStore = Broadcast.create();

export default BroadcastStore;
